import { ComponentProps } from 'react';
import AdInterstitial from '../AdInterstitial';

type Props = {
  count: number;
  experiment?: ComponentProps<typeof AdInterstitial>['experiment'];
};

export default function LightboxAd({ count, experiment }: Props) {
  if (count === 5) {
    return <AdInterstitial adId="gpt-photos1" adUnitPath="/4689141/alltrails_photos1_300x250" experiment={experiment} />;
  }

  if (count === 15) {
    return <AdInterstitial adId="gpt-photos2" adUnitPath="/4689141/alltrails_photos2_300x250" experiment={experiment} />;
  }

  if (count === 25) {
    return <AdInterstitial adId="gpt-photos3" adUnitPath="/4689141/alltrails_photos3_300x250" experiment={experiment} />;
  }

  return null;
}
